import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing * 4}px;
  > .avatar {
    align-self: center;
    margin-top: ${({ theme }) => theme.spacing * -15}px;
  }
  .distance {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.gray[400]};
    margin: ${({ theme }) => theme.spacing * 2}px 0 0 ${({ theme }) => theme.spacing * 7}px;
  }
`;

export const DisplayName = styled.h3`
  font-size: 36px;
  color: ${({ theme }) => theme.colors.gray[900]};
  margin: 0;
`;

export const ButtonsContainer = styled.div`
  margin: ${({ theme }) => theme.spacing * 6}px 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing * 4}px;
  > div {
    display: grid;
    grid-template-columns: 1fr 48px;
    grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
  }
`;

export const ContactContainer = styled.div`
  display: grid;
  grid-template-columns: 20px 1fr;
  align-items: center;
  grid-column-gap: ${({ theme }) => theme.spacing * 2}px;
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${({ theme }) => theme.colors.gray[400]};
    }
  }
  .phone {
    color: ${({ theme }) => theme.colors.gray[900]};
    > a {
      text-decoration: unset;
      color: inherit;
    }
  }
  .location {
    color: ${({ theme }) => theme.colors.gray[900]};
  }
  > p {
    font-weight: 700;
    margin: ${({ theme }) => theme.spacing * 2}px 0;
  }
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing * 4}px;
`;

export const OptionsButton = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.gray[200]};
  display: flex;
  justify-content: center;
  align-items: center;
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${({ theme }) => theme.colors.gray[500]};
    }
  }
`;

export const ReviewsLabel = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.gray[900]};
  font-size: 14px;
  > span {
    color: ${({ theme }) => theme.colors.primary[500]}
  }
`;

export const SectionLabel = styled.div`
  margin: 0 0 ${({ theme }) => theme.spacing * 4}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > h2 {
    font-size: 20px;
    color: ${({ theme }) => theme.colors.gray[900]};
  }
`;

export const ReviewContainer = styled.div`
  > div:first-child {
    > div {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`
